import { render, staticRenderFns } from "./DealWorkflowNode.vue?vue&type=template&id=39a3cd46&scoped=true"
import script from "./DealWorkflowNode.vue?vue&type=script&lang=js"
export * from "./DealWorkflowNode.vue?vue&type=script&lang=js"
import style0 from "./DealWorkflowNode.vue?vue&type=style&index=0&id=39a3cd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3cd46",
  null
  
)

export default component.exports